import React from "react";
import Table from "../../Table/tableEvent";

/*=============================================
=            Table Events Builder             =
=============================================*/

export const TablesEvent = (props) => {
  return (
    <>
      {props.allTables.map((e, key) => (
          <Table
            columns={props.columns}
            data={e.data}
            key={key}
            options={{
              large: true,
              downloads: {
                pdf: false,
                xlsx: false,
              },
            }}
          />
      ))}
    </>
  );
};
